<script>
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'
import CardsBlock from '@/components/organism/checkout/CardsBlock.vue'
import MethodBlock from '@/components/organism/checkout/MethodBlock.vue'
export default {
    name: 'ComplementaryPaymentBlock',
    components: { MethodBlock, CardsBlock, InputSelect },
    props: {
        stripe: {
            type: Object,
            default: () => {},
        },
        remainingSum: Number,
    },
    computed: {
        currency() {
            return this.$store.getters['active/currency']
        },
        cart() {
            return this.$cart || {}
        },
        priceSumUser() {
            return this.cart.calculated ? this.cart.calculation.price_sum_user : 0
        },
        paymentMethods() {
            return this.cart.calculation.payment_methods_with_expense_rule?.reduce((p, c) => {
                if (c !== this.$cardPayment) p.push(c.replace('-', '_'))
                return p
            }, [])
        },
        hasCardPayment() {
            return this.cart.calculation.payment_methods_with_expense_rule?.includes(
                this.$cardPayment
            )
        },
        isStripe() {
            return this.paymentMethod === this.$cardPayment
        },
        paymentMethod: {
            get() {
                return this.cart.payment_method?.replace('-', '_')
            },
            set(val) {
                this.cart.payment_method = val?.replace('_', '-') || null
            },
        },
        stripeForcedMinimum() {
            return (
                this.priceSumUser > this.remainingSum &&
                this.priceSumUser === this.stripe.minimumAmount &&
                this.isStripe
            )
        },
    },
    methods: {
        calculate() {
            this.cart.calculate()
        },
    },
}
</script>

<template lang="pug">
div(id="select_card")
    p.body-m.mb-2
        span(v-html="$t('order.complementary_payment', {price:$options.filters.toCurrency(priceSumUser, currency.locale, currency.currency_code)})")
        transition(name="alert")
            .alert.alert-info.d-flex.align-items-center.mb-0(v-if="stripeForcedMinimum")
                icon.text-white.mr-2(                    
                    icon="fa-solid fa-exclamation-circle"
                    size="lg")
                span.line-1(v-text="$t('order.stripe_forced_minimum', {minimum: $options.filters.toCurrency(stripe.minimumAmount, currency.locale, currency.currency_code), difference:  $options.filters.toCurrency(stripe.minimumAmount+remainingSum, currency.locale, currency.currency_code) })")
    method-block.hover-darker(
        v-if="!cart.isCanteenGroupOrder"
        v-for="(method, index) in paymentMethods"
        v-model="paymentMethod"
        @input="calculate"
        :class="{'border-0': index + 1 === paymentMethods.length && !hasCardPayment, 'border-top-1': !index}"
        :method="method"
        :key="`method-${index}`"
        complementary-payment)
    cards-block(
        v-if="hasCardPayment"
        v-model="paymentMethod"
        @input="calculate" 
        :stripe="stripe"
        :active="isStripe"
        id="test"
        complementary-payment)
        
</template>
